if(!customElements.get('product-reviews')) {
  class ProductReviews extends HTMLElement {
    constructor() {
      super();

      this.elSection = this.closest('section');
      this.elReviews = this.querySelector('[data-reviews]');
      this.elNext = this.querySelector('[data-next]');

      this.key = this.getAttribute('key');
      this.productId = this.getAttribute('product-id');
      this.productTitle = this.getAttribute('product-title');

      this.reviewsPerPage = Number(this.getAttribute('per-page'));
      this.totalPages = 0;
      this.currentPage = 1;
      this.nextCursor = null;

      this.reviews = [];
      this.currentReviews = [];

      this.setReviews();
      this.elNext.addEventListener('click', this.paginateReviews.bind(this));
    }

    async fetchReviews() {
      const url = `https://api.juniphq.com/v1/product_reviews?filter[product_remote_ids]=${this.productId}&include[]=customer${this.nextCursor ? `&page[after]=${this.nextCursor}` : ''}`;
      const requestOptions = {
        method: "GET",
        headers: {
          "Junip-Store-Key": this.key,
        },
        redirect: "follow",
      };

      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    }

    setReviews() {
      this.elReviews && this.elReviews.setAttribute('aria-busy', true);

      this.fetchReviews()
        .then(({ product_reviews, meta }) => {
          this.reviews = this.reviews ? [...this.reviews, ...product_reviews] : product_reviews;
          this.currentPage = this.currentPage ? this.currentPage : 1;
          this.nextCursor = meta.page.after;
          this.totalPages = Math.ceil(this.reviews.length / this.reviewsPerPage);

          this.appendReviews();
        })
        .catch(err => {
          console.log(err);
          this.elSection.display = 'none';
        })
    }

    appendReviews() {
      const isLast = this.currentPage == this.totalPages && !this.nextCursor;
      isLast && (this.elNext.style.display = 'none');

      let start = (this.currentPage - 1) * this.reviewsPerPage;
			let end = start + this.reviewsPerPage;
      
			this.currentReviews = [...this.currentReviews, ...this.reviews.slice(start, end)];
      this.elReviews.innerHTML = this.reviewsHtml();
    }

    reviewsHtml() {
      return this.currentReviews.map(review => { 
        const { first_name, last_name } = review.customer;
        const name = `${first_name ? first_name : 'Anonymous'}${last_name ? last_name.toString().split()[0].append('.') : ''}`
        return `
          <article aria-setsize="-1" class="product-reviews--review">
            <div class="product-reviews--review-header">
              <strong class="h3">${name}</strong>
              <span class="review-stars" style="--rating: ${review.rating}"></span>
            </div>
            <div class="product-reviews--review-content">
              <h3 class="product-reviews--review-title h2">
                ${review.title}
              </h3>
              <div class="product-reviews--review-body">
                ${review.body}
              </div>
            </div>
          </article>
        `
      }).join('')
    }

    paginateReviews() {
			this.currentPage++;
			this.currentPage >= 5 && this.nextCursor !== null ? this.setReviews() : this.appendReviews();
		}
  }

  customElements.define('product-reviews', ProductReviews)
}